import { SWOTItem } from './SWOTItem';
export default SWOTItem;